module.exports = __webpack_public_path__ + "img/bryan-kelly-sm.0d36c09.webp";